<template>
  <div id="app">
    <!-- <x-header></x-header> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepalive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepalive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {}
  },
  components: {},
  mounted () {
    window.addEventListener('unhandledrejection', evt => {
      if (evt && evt.reason && evt.reason.name === 'ChunkLoadError') {
        // 发现找不到新的 js 文件
        const alertContent = (
          <Fragment>
            <p>
              <Icon
                className="mr-10"
                id={alertError}
                size={16}
                fill={errorColor}
              />
              平台可能已更新，关闭提示将自动刷新页面使用最新版
            </p>
            <p>如刷新失败请手动刷新</p>
          </Fragment>
        )
        const config = {
          width: 400,
          handleCancel: () => window.location.reload(),
          handleEnsure: () => window.location.reload()
        }
        Modal.alert(alertContent, config) // 弹框提示用户
      }
    })
  }
}
</script>

<style src="./style/reset.css">
</style>
<style lang="scss" src="./style/common.scss">
</style>
<style lang="scss" src="./style/element-variables.scss">
</style>
<style>
@import 'mint-ui/lib/style.css';

body {
  font-size: 24px;
}
ul {
  padding-left: 0;
}
li {
  list-style: none;
}
.mint-indicator-mask {
  z-index: 1000;
}
.mint-radiolist {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.mint-radiolist-title {
  display: none;
}
.address-item .mint-cell {
  min-height: 100px;
}
.address-item .mint-cell-wrapper {
  font-size: 30px;
}
.address-item .mint-field-core {
  text-align: right;
}
.footer-order .mint-popup {
  width: 100%;
}

.remark .mint-field-core {
  font-size: 30px;
}
.mint-radio-input:checked + .mint-radio-core {
  background-color: #e93738 !important;
  border-color: #e93738 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue